/*
 * @Author: pengyong
 * @Date: 2020-11-17 11:07:44
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-19 21:29:06
 * @Description:
 * @FilePath: /exhibit/src/utils/signUtil.js
 */
import SHA256 from "crypto-js/sha256";
import changeDataType from "./objectToParam";

function signUtil(url, form_data, get_params, timestamp) {
    //console.log(url,get_params);
    let cloneData = JSON.parse(JSON.stringify(form_data));
    Object.assign(cloneData, get_params);
    cloneData.url = url;
    cloneData.ts = timestamp;

    let ordered = {};
    Object.keys(cloneData)
        .sort()
        .forEach(function(key) {
            if(key === 'url')
                ordered[key] = cloneData[key]
            else                
                ordered[key] = typeof cloneData[key] === "string" ? encodeURI(cloneData[key]).replace("+", "%20").replace("@", "%40") : cloneData[key];
        });
    let sign = (changeDataType(ordered)).replace(/\,/g,"%2C");
    console.log(sign, 'sign');
    sign = SHA256(sign).toString();
    return sign;
}

export default signUtil;



// WEBPACK FOOTER //
// ./src/utils/signUtil.js